import React,{useEffect} from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import { makeStyles } from '@material-ui/core/styles';
import styles from './View.Style'
import { Container } from '@material-ui/core';
import { BsFlag } from "react-icons/bs";
import visitImg from 'img/visits.png'
import expiresImg from 'img/expiresDateIcon.png'
import taggedImg from 'img/tagged.png'
import pendingImg from 'img/pending-review-tick.png'
import extraBenefits from 'img/extrabenefit.png'
import starImg from 'img/star-with-circle.png'
import coinsImg from 'img/coins-with-circle.png'
import { BiTimeFive } from "react-icons/bi";
import { FcIdea } from "react-icons/fc";
import { BiBulb } from "react-icons/bi";
import { FaRegCalendarAlt } from "react-icons/fa";
import defaultImgNova from 'img/nova_not_support.jpg'
import noDraftIdeasImg from 'img/no_draft_idea.png'
import { UserAvtar } from 'components_newui/Navbar/UserAvtar';
import defaultPhoto from 'img/default-photo.png'
import { IdeaTemplateSelectCard } from '../challengeFlow/IdeaTemplateSelectCard';
import IdeaPanel from 'components_newui/idea_panel/View'
import { useParams } from 'react-router-dom'

export function formatDateToShortMonth(dateStr) {
  const date = new Date(dateStr);
  const options = { day: '2-digit', month: 'short', year: 'numeric' };
  return date.toLocaleDateString('en-GB', options).replace(/ /g, ' ').replace(',', ',');
}



const useStylesChallenge = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  grid4block: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4,1fr)',
    gap:'1rem',
    margin:'2rem 0',
  },

  grid2block: {
    // gridTemplateColumns: 'repeat(2, 1fr)',

    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '2rem',
    margin: '2rem 0',

  }
  ,

  bigTitle:{
    fontFamily: 'VodafoneRg-bold', 
    fontSize: '2.5rem',
    margin: '1rem 0 1rem 0', 
    textAlign: 'center',
    paddingTop: '1rem',
    paddingBottom: '2rem',
    color:'#333',
  },
  title:{
    fontFamily: 'VodafoneRg-bold', 
    fontSize: '1.25rem',
    margin: '1rem 0 1rem 0', 
    textAlign: 'left',
    paddingTop: '1rem',
    color:'#333',
  },
  textsmall:{
    fontFamily: 'VodafoneRg-bold', 
    margin: '0 8px 0 0', 
    fontSize: '1rem',
    textAlign: 'left',
    color:'#333',
    display:'block',
    lineHeight:'1.4',
    // background: theme.palette.primary.dark,
    borderRadius: '1rem',
    padding: '2px 1rem'
},
text:{
    fontFamily: 'VodafoneRg-Regular', 
    margin: '0 0 8px 0', 
    fontSize: '1.25rem',
    textAlign: 'left',
    color:'#333',
    // color:theme.palette.headerText.main ,
    display:'block',
    lineHeight:'1.4',
},
  filterContainer:{
    display:'flex',
    alignItems:'center'
  },

  filterSelect:{
    fontFamily: 'VodafoneRg-bold', 
    fontSize: '1rem',
    backgroundColor: 'transparent',
    border: '1px solid',
    borderColor:theme.palette.primary.light,
    padding: '6px',
    borderRadius: '2rem' 
  },

  container__image:{
    display:'block',
    width:'100%',
    height:'400px',
    objectFit: 'cover',
    objectPosition:'top'
  },
  challengeblock:{
    marginTop:'1rem',
    marginBottom:'2rem'
  }

}));

const ChallengeDetail = (props) => {
  // console.log('props details', props)
  const idkey = useParams()
  const classes = useStylesChallenge();
  const [challengeStatus, setChallengeStatus] = React.useState('ACTIVE')
  const {getInnovateChallengeFn,listIdeaTemplate,listScorecardTemplate,getIdeaTemplatelistFn,getInnovateChallengeActiveTypesFn,getCommunitesAsGroup,getScorecardTemplatelistFn,innovateCategoryTypes } = props || {}
  const {passAllDataToDetails} = props?.location?.state || {}
  // console.log("🚀 ~ ChallengeDetail ~ passAllDataToDetails:", passAllDataToDetails,listIdeaTemplate,listScorecardTemplate)
 const {status:ideaStatus,title,numIdeas,visits,ends,desc,mainPhoto,sponsorPhoto:challengeOwnerPics,sponsorEmail,challengeTemplateId,ideaTemplateId,categoryTypeId,ideas} = passAllDataToDetails  || {}

  const endDataFormat =  formatDateToShortMonth(ends)

  const handleFilterChange = event => {
    const status = event.target.value
    setChallengeStatus(status)
  }
  useEffect(() => {
    getInnovateChallengeFn(idkey?.id)
}, [idkey?.id]);

  useEffect(() => {
    getIdeaTemplatelistFn?.();
    getScorecardTemplatelistFn?.();
    getInnovateChallengeActiveTypesFn?.();
    getCommunitesAsGroup?.();
  }, []);

  const selectedType = innovateCategoryTypes.find(
    (type) => +type.id === +categoryTypeId
  );

  return (
    <Container >
      <h2 className={classes.bigTitle}> {title}</h2>
    <div className={classes.grid4block} >
        <SingleChallegeComponent
            icon={<FaRegCalendarAlt />}
            challengeTitle='Timeline'
            challengeOwner={`Submissions End: ${endDataFormat}`}
            enableSubmitBtn={false}
        />  
        
        <SingleChallegeComponent
            icon={<BiTimeFive />}
            challengeTitle={`Status - ${ideaStatus}`}
            challengeOwner='Open - Accepting submissions'
            enableSubmitBtn
        />  

        <SingleChallegeComponent
            icon={<BiBulb />}
            challengeTitle='Ideas Submitted'
            challengeOwner={`${numIdeas}-idea`}
            enableSubmitBtn={false}
        />  
        <SingleChallegeComponent
            icon={<BsFlag />}
            challengeTitle='Challenge Views '
            challengeOwner={visits}
            enableSubmitBtn={false}
        />  

    </div>

    
    <div className={classes.challengeblock}>
        <h3 className={classes.title}>Challenge description</h3>
        <div className={classes.container__imageblock}>
            <img className={classes.container__image} src={ mainPhoto !=='' || mainPhoto === undefined ? mainPhoto : defaultImgNova} alt='carousel img' />
        </div>
        <p className={classes.text}>{desc}</p>
    </div>

<div className={classes.grid2block}>
    <div className={classes.challengeblock}>
          <h3 className={classes.title}>Selected Challenge Template</h3>
          {listScorecardTemplate
            ?.filter((item) => item?.id === challengeTemplateId)
            .map((item, index) => (
              <IdeaTemplateSelectCard
                key={item.templateName}
                ideaName={item.templateName}
                currentIndex={index}
                onClick={() => { }} // Consider removing or implementing this
                idealistId={item.id}
                selectedTemplateId={challengeTemplateId}
              />
            ))}

    </div>  

    <div className={classes.challengeblock}>
        <h3 className={classes.title}>Selected Idea Template </h3>
                  {listIdeaTemplate
                   ?.filter((item) => item?.id === ideaTemplateId)
                   .map((item, index) => (
                        <IdeaTemplateSelectCard
                            key={item.templateName}
                            ideaName={item.templateName}
                            currentIndex={index}
                            onClick={() => {}}
                            idealistId={item.id}
                            selectedTemplateId={ideaTemplateId}
                        />
                  ))}
    </div>  
</div>

      <div className={classes.challengeblock}>
        <h3 className={classes.title}>Category Selected </h3>      
          {selectedType && <p className={classes.text}>{selectedType.name}</p>}
       
    </div>

      <div className={classes.challengeblock}>
        <h3 className={classes.title}>Communites Invited</h3>
        <UserProfileGrid
          userAvtar={challengeOwnerPics}
          ownerEmail={sponsorEmail || ''}
        />
      </div>

    <div className={classes.challengeblock}>
        <h3 className={classes.title}>Challenge Owners</h3>
        <UserProfileGrid 
          userAvtar={challengeOwnerPics}
          ownerEmail={sponsorEmail || ''}
        />
       
    </div>


        <h3 className={classes.title}>Ideas submitted for this challenge</h3>
          <div className={classes.horizontal_line} />
          <div className={classes.tagwrp}>
              {/* <div className={classes.header}>All ideas </div> */}

              <IdeaListComponent 
                listIdeas={ideas || []}
              />
          </div>



    </Container >
  )
}

export default withStyles(styles)(ChallengeDetail)








const useSingleChallegeComponentStyles = makeStyles((theme) => (
    
    {
    root: {
      width: '100%',
    },
    headingbox:{
        backgroundColor:'rgba(230, 0, 1, 0.09)',
        borderRadius: '0.5rem',
        padding: '1rem',
        boxSizing: 'border-box',
        marginBottom:'0rem',
    },
    headingIcon:{
        backgroundColor: 'rgba(230, 0, 1, 0.05)',
        padding: '4.5px',
        borderRadius: '50%',
        boxSizing: 'border-box',
        margin: '0 0 0.5rem 0 ',
        lineHeight: '0',
        height: '25px',
        width: '25px',
        display: 'inline-block',
    },
    fieldrow:{
        borderBottom: '1px solid #ccc',
        padding: '1rem 0',
        display: 'grid',
        gridTemplateColumns: '40% 1fr',
        gap: '1rem'
    },
    title:{
        fontFamily: 'VodafoneRg-bold', 
        fontSize: '1rem',
        margin: '0.5rem 0', 
        textAlign: 'left',
        paddingTop: '0rem',
        color:'#333',
      },
    textsmall:{
        fontFamily: 'VodafoneRg-regular', 
        margin: '0 0 0 0', 
        fontSize: '0.9rem',
        textAlign: 'left',
        color:'#333',
        display:'block',
        lineHeight:'1.4'
    },
    alignbtn:{
        display:'flex',
        alignItems:'center',
        gap:'1rem'
    },
    selectbtn:{
        margin:'1rem 0 0',
        color: theme.palette.headerText.main,
        border: '1px solid',
        display: 'block',
        padding: '0.5rem',
        fontSize: '1rem',
        boxSizing: 'border-box',
        textAlign: 'center',
        transition: 'all 300ms ease',
        fontFamily: 'VodafoneRg-Regular',
        borderRadius: '5px',
        backgroundColor: theme.palette.primary.dark,
        borderColor:theme.palette.primary.dark,
        cursor:'pointer',
        '&:hover':{
            backgroundColor:'transparent'
        }
    }
}));

const SingleChallegeComponent = (props) =>{
    const classes = useSingleChallegeComponentStyles();
    const {challengeTitle,ideaSubmitted,challengeOwner,submissionsEnd,category,enableSubmitBtn,icon} = props || {}

    return(
            <div className={classes.headingbox}>
                <div className={classes.headingIcon}> {icon  ||  <span><BsFlag /></span>} </div>
                {/* <p className={classes.textsmall}><span>Submitted</span> : <span>{ideaSubmitted} Ideas</span></p> */}
                <h3 className={classes.title}>{challengeTitle}</h3>
                <p className={classes.textsmall}> {challengeOwner}</p>
                {
                    enableSubmitBtn === true ? 
                    <div className={classes.alignbtn}>
                     <button type='button' onClick={()=>{}} className={classes.selectbtn}>Submit Idea</button>
                    </div> 
                    : null
                }
                
            </div>
            
    )
}






const userProfileComponentStyles = makeStyles((theme) => (
  {
  root: {
    width: '100%',
  },
  headingbox:{
      backgroundColor:'rgba(230, 0, 1, 0.09)',
      borderRadius: '0.5rem',
      padding: '1rem',
      boxSizing: 'border-box',
      marginBottom:'0rem',
  },
  headingIcon:{
      backgroundColor: 'rgba(230, 0, 1, 0.05)',
      padding: '4.5px',
      borderRadius: '50%',
      boxSizing: 'border-box',
      margin: '0 0 0.5rem 0 ',
      lineHeight: '0',
      height: '25px',
      width: '25px',
      display: 'inline-block',
  },
  fieldrow:{
      borderBottom: '1px solid #ccc',
      padding: '1rem 0',
      display: 'grid',
      gridTemplateColumns: '40% 1fr',
      gap: '1rem'
  },
  title:{
      fontFamily: 'VodafoneRg-bold', 
      fontSize: '1rem',
      margin: '0.5rem 0', 
      textAlign: 'left',
      paddingTop: '0rem',
      color:'#333',
    },
  textsmall:{
      fontFamily: 'VodafoneRg-regular', 
      margin: '0 0 0 0', 
      fontSize: '0.9rem',
      textAlign: 'left',
      color:'#333',
      display:'block',
      lineHeight:'1.4'
  },
  alignbtn:{
      display:'flex',
      alignItems:'center',
      gap:'1rem'
  },
  


  userinfo:{
    display:'flex',
    alignItems: 'center',
    width: '100%',
    padding: '8px 0'
  },
  useRole:{
    marginLeft:'8px',
  },
  profilePicHolder: {
    position: 'relative',
    display: 'flex',
    alignItems:'center'
  },
  profilePic: {
    height: '40px',
    width: '40px',
    borderRadius: '50%',
    boxShadow: '0px 2px 3px #33333399',
    marginLeft:'.5rem',
  },

  
}));


const UserProfileGrid = (props)=>{
  const {userAvtar,ownerEmail} = props || {}
   const classesName  = userProfileComponentStyles()
   return(
     <div className={classesName.userinfo}>
       <img
             src={userAvtar}
             className={classesName.profilePic }
             onError={({ currentTarget }) => {
                 currentTarget.onerror = null
                 currentTarget.src = defaultPhoto
             }}
             alt="User Profile"
         />
         <div className={classesName.useRole}>
             <p className={classesName.textsmall}>{ownerEmail}</p>
             {/* <em className={classesName.textsmall}>df</em> */}
         </div>
     </div>
   )
 }




 const userIdeaListComponentStyles = makeStyles((theme) => (
  {
  root: {
    width: '100%',
  },
  ideaGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    alignItems: "center",
    justifyItems: "center",
    '@media (max-width:1250px)': { 
        gridTemplateColumns: "repeat(3, 1fr)",
    },
    '@media (max-width:1050px)': { 
        gridTemplateColumns: "repeat(2, 1fr)",
    },
    '@media (max-width:720px)': { 
        gridTemplateColumns: "1fr",
    },
  },

  noIdeaImg: {
      height: '210px',
      width: '288px',
      marginBottom: '20px',
      margin:'2rem auto',
      display:'block',
      '@media (max-width:720px)': { 
        
          height: '110px',
          width: '140px',
      },
  },
  noIdeaTitle: {
      textAlign: 'center',
      fontSize: '32px',
      color: '#333333',
      fontFamily: 'VodafoneRg-Regular',
      '@media (max-width:720px)': { 
          fontSize:'16px'
      }
  },
  nofoundwrp:{
    margin:'2rem auto',
    padding:'2rem 0'
  }

}));

const IdeaListComponent = (props)=>{
  const classes = userIdeaListComponentStyles();
  const {listIdeas}= props || {}
  return(
    listIdeas?.length > 0 ? (
      <div className={classes.ideaGrid}>
        {listIdeas.map(idea => (
            <IdeaPanel key={idea.id} urlId={idea.id} isInnovate={idea?.isInnovate}  idea={idea} />
          ))
        }
      </div>
    ) : (
      <div className={classes.nofoundwrp}>
        <img src={noDraftIdeasImg} className={classes.noIdeaImg} alt="no idea img" />
        <div className={classes.noIdeaTitle}>No ideas found</div>
      </div>
    )
  )
}